import { Flex, Typography } from '@aloft/toolkit-sui';

import { useAppSelector } from '../../redux/hooks.ts';
import { CommentarySection } from './components/CommentarySection.tsx';
import { getMethodologyText } from './consts.ts';
import { getCommentarySectionText } from './utils.ts';
import { selectSubjectPropertyType } from '../../redux/features/selectors/selectSubjectPropertyType.ts';

export const Methodology = () => {
  const propertyType = useAppSelector(selectSubjectPropertyType);
  if (propertyType === undefined) {
    throw new Error('Property type is undefined');
  }

  const methodologyText = getMethodologyText(propertyType);

  return (
    <CommentarySection {...getCommentarySectionText('methodology')}>
      <Flex flexDirection="column" gap={2}>
        {methodologyText.map((text, index) => (
          <Typography key={index} variant="body1">
            {text}
          </Typography>
        ))}
      </Flex>
    </CommentarySection>
  );
};
